import type { SVGProps } from 'react';
const SvgHighlight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#highlight_svg__a)">
      <path
        fill="currentColor"
        d="m6 14 3 3v5h6v-5l3-3V9H6v5Zm5-12h2v3h-2V2ZM3.5 5.88l1.41-1.41 2.12 2.12L5.62 8 3.5 5.88Zm13.46.71 2.12-2.12 1.41 1.41L18.38 8l-1.42-1.41Z"
      />
    </g>
    <defs>
      <clipPath id="highlight_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHighlight;
